const templateManagementTableItems = [
    { title: "Name", key: "Name", order: 1, isCheckBox: false, isDate: false, maxWidth: "250px", fw: "500" },
    { title: "Description", key: "Description", order: 2, isCheckBox: false, isDate: false, maxWidth: "500px", fw: "unset" },
    { title: "Protected", key: "IsProtected", order: 3, isCheckBox: true, isDate: false, maxWidth: "150px", fw: "unset" },
    { title: "Created By", key: "CreatedBy", order: 4, isCheckBox: false, isDate: false, maxWidth: "200px", fw: "unset" },
    { title: "Created date", key: "CreatedDateUTC", order: 5, isCheckBox: false, isDate: true, maxWidth: "150px", fw: "unset" },

]

export default templateManagementTableItems